import { ModelHelper } from '../classes/model-helper';

export class Region {
	countryCode: string;
	name: string;
	regionCode: string;

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 * @returns Region
	 */
	static map(data: any, item: Region = new Region()): Region {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return Region
	 */
	public map(data: any): Region {
		ModelHelper.map(data, this, 'countryCode');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'regionCode');

		return this;
	}

	/**
	 * Prepare data for API
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		if (data) {
			if (data.countryCode && data.regionCode) {
				return { countryCode: data.countryCode, regionCode: data.regionCode };
			} else if (data.regionCode) {
				return { regionCode: data.regionCode };
			}
		} else {
			return null;
		}
	}
}
